<template>
	<div id="aboutUs" class="mainPage">
		<div id="banner">
			<div class="container">
				<div class="text">
					<h2>深能智见</h2>
					<p style="width:100%;">致力于成为业内领先的智能化数据服务商</p>
				</div>
			</div>
			<img src="../assets/img/ab.jpg"/>
		</div>
		<div class="main">
			<div class="mainBox">
				<div class="title">
					<h2>公司简介</h2>
					<p>
						<span>PROFILE</span>
					</p>
				</div>
				<div class="container">
					<div class="profile">
						<p>武汉深能智见科技股份有限公司，是武汉市武昌区政府重点招商引资企业。</p>
						<p>公司致力于为企业和个人提供专业、全面、安全、可靠的机器人流程自动化、数字流程自动化解决方案。核心技术涵盖机器人流程自动化（ RPA-Robotic Process Automation）、数字流程自动化（DPA-Digital Process Automation），流程挖掘、自然语言处理（NLP）、智能对话交互、文字识别与图像识别、视频自动化处理等。目前正在银行、证券、保险、政府、零售、医疗等行业中广泛应用，产品和服务赢得了市场高度认可。</p>
					</div>
				</div>
			</div>
			<div class="mainBox gdbjBox">
				<div class="title">
					<h2>股东背景</h2>
					<p>
						<span>SHAREHOLDER</span>
					</p>
				</div>
				<div class="container gdbj">
					<div class="boxImg">
						<img src="../assets/img/gd.png" class="logo gd"/>
						<img src="../assets/img/ts.png"  class="logo ts"/>
						<img src="../assets/img/zy.png"  class="logo zy"/>
						<img src="../assets/img/yd.png"  class="logo yd"/>
						<img src="../assets/img/pt10.png"  class="logo jd"/>
						<img src="../assets/img/gdbg.png" class="bgImg"/>
					</div>
				</div>					
			</div>
			<div class="mainBox">
				<div class="title">
					<h2>团队介绍</h2>
					<p>
						<span>TEAM</span>
					</p>
				</div>
				<div class="container team">
					<div class="row">
						<div class="col-md-4">
							<img src="../assets/img/map.png"/>
						</div>
						<div class="col-md-8 text">
							<p>智见除武汉建立了研发中心，在北京、上海、深圳、贵阳等客户集中的地区也有专业的业务、运营、咨询、技术人员，并由合伙人带队。</p>
							<p style="color: #004767; font-weight: bold;font-size:16px;">技术（产品）人员占比：90%</p>
							<p style="margin-bottom:0;">非技术人员占比：10%</p>
						</div>
					</div>
				</div>
			</div>
			<div class="mainBox">
				<div class="serve" :style="serveBg">
					<div class="serveBox">
						<div class="container ">
							<!-- <img class="snzj" src="../assets/img/snzj.png"/> -->
							<div class="title">
								<h2>团队优势</h2>
								<p>
									<span>ADVANTAGE</span>
								</p>
							</div>
							<div class="row">
								<div class="col-md-4">
									<div class="box">
										<p class="icon"><i class="iconfont icon-ai"></i></p>
										<!-- <span>专业技术团队</span> -->
										<p>团队深耕AI技术多年，主要由具有长期经验的产品开发及数据分析人员组成，非技术人员占比非常低</p>
									</div>
								</div>
								<div class="col-md-4">
									<div class="box" >
										<p class="icon"><i class="iconfont icon-tuandui"></i></p>
										<!-- <span>多项技术突破</span> -->
										<p>团队精干，由于技术架构的优势，服务效率高，打破了传统堆人服务的模式，大大降低了人员需求  </p>
									</div>
								</div>
								<div class="col-md-4">
									<div class="box" >
										<p class="icon"><i class="iconfont icon-shuju"></i></p>
										<!-- <span>多项技术突破</span> -->
										<p>数据分析能力强，整个产品体系架构面向数据准备的全流程，而不是简单的IT需求响应，处理数据快而精准 </p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="mainBox">
				<div class="partner container">
					<div class="title">
						<h2>合作伙伴</h2>
						<p>
							<span>PARTNER</span>
						</p>
					</div>
					<div class="partnerBox">
						<div class="box" v-for="item in ptLogo">
							<div class="boxImg">
								<img :src="require('../assets/img/pt'+item+'.png')"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default{
	name:'AboutUs',
	data() {
		return {
			serveBg:{
				backgroundImage:'url(' + require('../assets/img/abt.jpg') + ')'
			},
			gdbjBg:{
				backgroundImage:'url(' + require('../assets/img/abbg.jpg') + ')'
			},
			ptLogo:['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20']
		}
	}
}
</script>

<style lang="scss">
#aboutUs{
	.mainBox{
		.profile{
			padding:50px 0;
			p{
				line-height: 25px;
				font-size: 17px;

			}
		}
		&.gdbjBox{
			// background-color: #f1f1f1;
			padding:50px 0;
			margin-bottom: 50px;
		}
		.gdbj{
			display: flex;
			padding:50px 0;
			.boxImg{
				position: relative;
				text-align: center;
				width: 100%;
				margin-top: 70px;
				img.bgImg{
					width: 650px;
				}
				img.logo{
					position: absolute;
					width: 180px;
					&.gd{
						top: -80px;
						left: 50%;
						transform:translateX(-50%)
					}
					&.jd{
						top: -15px;
						left: 20px;
						width: 230px;
					}
					&.yd{
						bottom: -27px;
						left: 90px;
						width: 160px;
					}
					&.zy{
						bottom: -29px;
						right: 50px;
						width: 180px;
					}
					&.ts{
						top: -21px;
						right: 50px;
						width: 180px;
					}
				}
			}
		}
		.team{
			margin-top:35px;
			margin-bottom:50px;
			img{
				width: 80%;
			}
			.text{
				padding-top: 35px;
				p{
					margin-bottom: 35px;
					font-size: 17px;
				}
			}
		}
		&.feedback{
			background-color: rgb(245,245,245);
			padding:40px 0;
			form{
				>div{
					margin-bottom: 25px;
				}
			}
		}
		.serve{
			.title{
				margin-bottom: 50px;
			}
		}
	}
}


</style>